import React, { Component } from 'react'

import { pink } from '@mui/material/colors'
import { createTheme, StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2'

export const theme = createTheme({
  // Only what is actually ours: MUI's own error, warning and success are fine, and not restating
  // them is one less palette to keep in step.
  palette: {
    // Blue-violet to match the main app's accent (and the pink→blue brand logo).
    primary: { main: '#4f5bd5' },
    secondary: { main: pink[600] },
    // Soft gray canvas so the white header and table cards read as elevated panels.
    background: { default: '#f4f6f8' },
  },
  // Compact inputs app-wide: size 'small' on FormControl cascades to Select/InputLabel/OutlinedInput; TextField covers text fields + date pickers.
  components: {
    MuiTextField: { defaultProps: { size: 'small' } },
    MuiFormControl: { defaultProps: { size: 'small' } },
    MuiAutocomplete: { defaultProps: { size: 'small' } },
    // MUI zeroes DialogContent top padding after DialogTitle, clipping first-row Grid floating labels; restore padding (same selector as MUI's → wins by source order, no !important).
    MuiDialogContent: {
      styleOverrides: {
        root: { '.MuiDialogTitle-root + &': { paddingTop: 16 } },
      },
    },
  },
})

export default (DecoratedComponent: React.ComponentType<any>) =>
  class extends Component<any> {
    render() {
      return (
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DecoratedComponent {...this.props} />
            </LocalizationProvider>
          </ThemeProvider>
        </StyledEngineProvider>
      )
    }
  }
